const BUNDLE_EXPLORER_FILE_EXTENSION = ".json";

/** Whether the S3 object detail UI should show the Bundle Explorer action. */
export function showBundleExplorerForS3ObjectKey(objectKey: string): boolean {
  const key = objectKey.trim();
  if (!key) return false;
  return key.toLowerCase().endsWith(BUNDLE_EXPLORER_FILE_EXTENSION);
}
